import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommunityHeader = _resolveComponent("CommunityHeader")!
  const _component_CommunitySwitch = _resolveComponent("CommunitySwitch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CommunityHeader),
    _createVNode(_component_CommunitySwitch)
  ], 64))
}